import { render, staticRenderFns } from "./voice_room.vue?vue&type=template&id=33c84380"
import script from "./voice_room.vue?vue&type=script&lang=js"
export * from "./voice_room.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports